import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, Flex } from "sprout-ui-primitives";
import Avatar from "@sprout/client-components/dist/Avatar";
import styled, { css } from "styled-components";
import { themeGet } from "sprout-ui-theme";
import { usePostPageEditor } from "../PostPageEditorContext";
import PostPageCommentEditor from "../PostPageCommentEditor";
import PostPageCommentMeta from "./PostPageCommentMeta";
import PostPageCommentText from "./PostPageCommentText";
import { PostPageCommentProvider } from "./PostPageCommentContext";
import useCommentFocus from "./useCommentFocus";
const PostPageReplyWrapper = styled(Flex)`
  ${({ $focused  })=>$focused && css`
      border: 1px solid ${themeGet("colors.blue.500")};
    `}
`;
const PostPageCommentReply = (props)=>{
    const { reply , parentCommentNodeId , parentCommentId , itemId  } = props;
    const { owner , id  } = reply;
    const { state  } = usePostPageEditor();
    const openEditCommentEditor = state.editor === "EDIT_COMMENT" && state.editorPosition === id;
    const initialState = useMemo(()=>({
            parentCommentId,
            parentCommentNodeId,
            commentId: id
        }), [
        id,
        parentCommentNodeId,
        parentCommentId
    ]);
    const replyHash = `#comment-${id}-${parentCommentId}`;
    const { focused , ref  } = useCommentFocus(replyHash);
    if (!owner) return null;
    return /*#__PURE__*/ _jsxs(PostPageCommentProvider, {
        initialState: initialState,
        children: [
            /*#__PURE__*/ _jsx(PostPageCommentEditor, {
                itemId: itemId,
                desktopPt: 1,
                desktopVariant: "reply",
                cacheKey: `#reply-${id}`,
                comment: reply,
                open: openEditCommentEditor ? state.variant : undefined
            }),
            !(openEditCommentEditor && state.variant === "desktop") && /*#__PURE__*/ _jsxs(PostPageReplyWrapper, {
                py: 1,
                px: 3,
                $focused: focused,
                ref: ref,
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        flex: "none",
                        mr: 2,
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            user: owner,
                            navigable: true,
                            size: 36
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        flex: "1",
                        minWidth: "0",
                        children: [
                            /*#__PURE__*/ _jsx(PostPageCommentMeta, {
                                parentCommentId: parentCommentId,
                                comment: reply
                            }),
                            /*#__PURE__*/ _jsx(PostPageCommentText, {
                                comment: reply
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default PostPageCommentReply;
